import React, { Suspense, useContext, useEffect } from "react";
import "./twitter.scss";
import Loading from "../loading/Loading";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import { twitterDetails } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

const renderLoader = () => <Loading />;

const cantDisplayError = `
  <div class='centerContent'>
    <h2>Can't load Twitter. Check privacy or ad-block settings.</h2>
  </div>
`;

export default function Twitter() {
  const { isDark } = useContext(StyleContext);
  const widthScreen = window.innerWidth;

  useEffect(() => {
    const timer = setTimeout(() => {
      const twitterDiv = document.getElementById("twitter");
      if (twitterDiv && !twitterDiv.innerHTML.includes("iframe")) {
        twitterDiv.innerHTML = cantDisplayError;
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  if (!twitterDetails.display || !twitterDetails.userName) {
    return null;
  }

  return (
    <Suspense fallback={renderLoader()}>
      <div className="tw-main-div" id="twitter">
        <div className="centerContent">
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName={twitterDetails.userName}
            options={{
              height: 400,
              width: widthScreen > 600 ? 500 : 320
            }}
            placeholder={renderLoader()}
            theme={isDark ? "dark" : "light"}
            noFooter={true}
          />
        </div>
      </div>
    </Suspense>
  );
}
